import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import { Checkbox } from '@sravni/react-design-system';
import type { FormEvent } from 'react';

import { useAppSelector } from 'shared/lib';

import { selectRegistrationAddressFields } from 'entities/creditForm';
import type { TPledgeEstateFields } from 'entities/pledgeEstateForm';

export const PledgeAddressIsRegistrationCheckbox: FC<IFieldFactoryProps> = (props) => {
  const { label } = props;

  const { registrationAddress, registrationAddressFlat } = useAppSelector(selectRegistrationAddressFields);
  const { watch, setValue, clearErrors } = useFormContext<TPledgeEstateFields>();
  const isSameAddress = watch('isPledgeAddressSameRegistration');

  const onChange = (event: FormEvent<HTMLInputElement>) => {
    // сначала переносим / очищаем данные в адресе проижвания и только потом включаем его отображение
    const isChecked = event.currentTarget.checked;
    clearErrors('pledgeEstateAddress');

    if (isChecked && registrationAddress) {
      setValue(
        'pledgeEstateAddress',
        {
          data: {
            ...registrationAddress.data,
          },
          value: registrationAddress.value,
          label: registrationAddress.label,
        } as TPledgeEstateFields['pledgeEstateAddress'],
        { shouldValidate: true },
      );
      setValue('pledgeEstateAddressFlat', registrationAddressFlat, { shouldValidate: true });
    } else {
      setValue('pledgeEstateAddress', null, { shouldValidate: false });
      setValue('pledgeEstateAddressFlat', '', { shouldValidate: false });
    }

    setValue('isPledgeAddressSameRegistration', event.currentTarget.checked);
  };

  return (
    <Checkbox
      checked={isSameAddress}
      onChange={onChange}
    >
      {label}
    </Checkbox>
  );
};
